import Vue from 'vue';
import Router, { RouterOptions } from 'vue-router';

import { Storage } from '@/enums/storage.enum';
import { mainRoute } from './routes/main.route';
import { notFoundRoute } from './routes/notFound.route';
import { startRoute } from './routes/start.route';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [startRoute, mainRoute, notFoundRoute]
} as RouterOptions);

router.beforeEach((to: any, from: any, next: any) => {
  if (to.matched.some((record: any) => record.meta.authorized)) {
    if (localStorage.getItem(Storage.TOKEN) === null) {
      next({ name: 'login' });
    } else {
      // Sprawdzanie roli
      next();
    }
  } else {
    next();
  }
});

export default router;
